import fetch from '../../utils/fetch'

export function getPayCode(params) {
    return fetch({
        url: '/api/xports/verifycode',
        method: 'POST',
        data: params
    })
}

export function getCardInfo(parkinglotId,plate) {
    return fetch({
        url: '/api/xports/memberCarNumberEntryInfo?parkinglotId='+parkinglotId+"&plate="+plate,
        method: 'GET',
    })
}

/* export function getCardInfo(params) {
    return fetch({
        url: '/api/xports/card/info',
        method: 'POST',
        data: params
    })
} */

export function getDiscounts(params) {
    return fetch({
        url: '/api/xports/card/pay/discounts',
        method: 'POST',
        data: params
    })
}

export function memberPay(params) {
    return fetch({
        url: '/api/xports/card/pay',
        method: 'POST',
        data: params
    })
}
